import { buttonProperties, classNamesFunction, getIcon, getNativeProps, } from '@fluentui/react';
import { ThrowOnUndefinedColorContext } from '@m365-admin/customizations';
import * as React from 'react';
import { getIconMap } from './subway-node.styles';
import { SubwayNavNodeState } from './subway-node.types';
const getClassNames = classNamesFunction();
export class SubwayNodeBase extends React.Component {
    static defaultProps = {
        state: SubwayNavNodeState.Current,
        isSubStep: false,
        disabled: false,
    };
    static contextType = ThrowOnUndefinedColorContext;
    constructor(props) {
        super(props);
        this._onClickStep = this._onClickStep.bind(this);
    }
    render() {
        const { styles, isSubStep, disabled = false, isVisuallyDisabled = false, state, subSteps, index, rootAs, onRenderStep = this._onRenderStep, theme, onRenderStepIcon = this._onRenderStepIcon, } = this.props;
        const iconRecord = getIcon(getIconMap(isSubStep ?? false)[state]);
        const buttonProps = getNativeProps(this.props, buttonProperties);
        const classNames = getClassNames(styles, {
            isSubStep: isSubStep,
            disabled: disabled,
            isVisuallyDisabled: disabled && isVisuallyDisabled,
            state,
            iconRecord: iconRecord,
            hasSubSteps: subSteps ? subSteps.length > 0 : false,
            index: index,
            theme: theme,
            colorThrowContext: this.context,
        });
        const RootElement = rootAs ?? 'button';
        return (React.createElement(RootElement, { className: classNames.root, "data-is-focusable": !disabled, ...buttonProps, ...(!disabled && { onClick: this._onClickStep }) }, onRenderStep(this.props, classNames, iconRecord, onRenderStepIcon)));
    }
    _onRenderStep = (props, classNames, iconRecord, onRenderStepIcon) => {
        const { label } = props;
        return (React.createElement(React.Fragment, null,
            onRenderStepIcon?.(props, classNames, iconRecord),
            React.createElement("div", { className: classNames.spacer }),
            React.createElement("div", { className: classNames.labelWrapper },
                React.createElement("div", { className: classNames.label }, label),
                React.createElement("div", { className: classNames.labelSelected, "aria-hidden": true }, label))));
    };
    _onClickStep = () => {
        this.props.onClickStep?.(this.props);
    };
    _onRenderStepIcon = (props, classNames, iconRecord) => {
        const { isSubStep, state } = props;
        const isIconOnly = isSubStep &&
            (state === SubwayNavNodeState.Error ||
                state === SubwayNavNodeState.Completed ||
                state === SubwayNavNodeState.WizardComplete);
        const strokeRadius = isSubStep ? '18%' : '43%';
        return (React.createElement("svg", { viewBox: "0 0 16 16", className: classNames.iconContainer, "aria-label": props.iconAriaLabel, xmlns: "http://www.w3.org/2000/svg" },
            iconRecord && (React.createElement(React.Fragment, null,
                !isIconOnly && (React.createElement("circle", { r: strokeRadius, cx: "50%", cy: "50%", className: classNames.iconBackPlate })),
                React.createElement("text", { x: "50%", y: "50%", dy: "0.5em", textAnchor: "middle", className: classNames.icon }, iconRecord.code))),
            !isIconOnly && (React.createElement("circle", { r: strokeRadius, cx: "50%", cy: "50%", className: classNames.iconRing }))));
    };
}
//# sourceMappingURL=subway-node.base.js.map